import React, { useContext } from "react";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { LIKE, LOVE, useFbReactionsHashMap } from "../DataHooks/useFbReactions";
import { Tooltip } from "@mui/material";
import { store } from "./store";

export const AudienceReaction = ({ psid, pageId }) => {
  const { state } = useContext(store);
  const { video } = state;
  const { data: reactionsHashMap } = useFbReactionsHashMap(
    `${pageId}_${video.id}`
  );

  if (!psid) {
    return null;
  }

  const reaction = reactionsHashMap[psid];
  return (
    <>
      {reaction && reaction.type === LIKE && (
        <span>
          {" "}
          <Tooltip title={`User liked your post`}>
            <ThumbUpIcon sx={{ color: "#1877F2" }} fontSize="small" />
          </Tooltip>
        </span>
      )}
      {reaction && reaction.type === LOVE && (
        <span>
          {" "}
          <Tooltip title={`User loved your post`}>
            <FavoriteIcon sx={{ color: "red" }} fontSize="small" />
          </Tooltip>
        </span>
      )}
    </>
  );
};
